// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../../../index.mjs";
export const LiteralType = {
    boolean: (value) => {
        return {
            value: value,
            type: "boolean",
            _visit: function (visitor) {
                return FernIr.dynamic.LiteralType._visit(this, visitor);
            },
        };
    },
    string: (value) => {
        return {
            value: value,
            type: "string",
            _visit: function (visitor) {
                return FernIr.dynamic.LiteralType._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "boolean":
                return visitor.boolean(value.value);
            case "string":
                return visitor.string(value.value);
            default:
                return visitor._other(value);
        }
    },
};
